import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [me, p, b] = await Promise.all([
        api.get("/auth/me"),
        api.get("/profile"),
        api.get("/billing/status"),
      ]);
      setUser(me.data);
      setProfile(p.data);
      setBilling(b.data);
    } catch {
      setUser(null);
      setProfile(null);
      setBilling(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("lq_token");
    if (!token) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const login = async (email, password, remember) => {
    const r = await api.post("/auth/login", { email, password, remember });
    localStorage.setItem("lq_token", r.data.token);
    await refresh();
    return r.data.user;
  };

  const signup = async (email, password) => {
    const r = await api.post("/auth/signup", { email, password });
    localStorage.setItem("lq_token", r.data.token);
    await refresh();
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("lq_token");
    setUser(null);
    setProfile(null);
    setBilling(null);
    window.location.href = "/";
  };

  const updateProfile = async (patch) => {
    const r = await api.patch("/profile", patch);
    setProfile(r.data);
    return r.data;
  };

  const refreshBilling = async () => {
    const r = await api.get("/billing/status");
    setBilling(r.data);
    return r.data;
  };

  return (
    <AuthContext.Provider
      value={{ user, profile, billing, loading, login, signup, logout, refresh, updateProfile, refreshBilling }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
